import { Checkbox, Row } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import RestoreSelectedActionButton from './button/RestoreSelectedActionButton'
import DeleteSelectedActionButton from './button/DeleteSelectedActionButton'
import UnrestrictSelectedActionButton from './button/UnrestrictSelectedActionButton'
import RestrictSelectedActionButton from './button/RestrictSelectedActionButton'

export default function SelectedArtifactsActions({
  artifacts,
  status,
  checkedArtifacts,
  setCheckedArtifacts,
  refetch,
  patron,
  selectAllArtifacts,
  setSelectAllArtifacts,
}) {
  const { t } = useTranslation()

  const selectAllArtifactsOnChange = () => {
    setSelectAllArtifacts((prev) => {
      if (prev) {
        setCheckedArtifacts([])
      } else {
        setCheckedArtifacts(artifacts.map((artifact) => artifact.id))
      }
      return !prev
    })
  }

  const checkedArtifactsIndicator = (
    <div key="checkedArtifactsIndicator" growX>
      {t('artifacts.selected', '{ numberOfSelectedArtifacts } selected', {
        numberOfSelectedArtifacts: checkedArtifacts.length,
      })}
    </div>
  )

  let actionButtons = []
  switch (status) {
    case 'tombstoned':
      actionButtons = [
        checkedArtifacts.length > 0 && checkedArtifactsIndicator,
        checkedArtifacts.length > 0 && (
          <RestoreSelectedActionButton
            key="restore"
            checkedArtifacts={checkedArtifacts}
            setCheckedArtifacts={setCheckedArtifacts}
            refetch={refetch}
            patron={patron}
          />
        ),
        checkedArtifacts.length > 0 && (
          <DeleteSelectedActionButton
            key="delete"
            checkedArtifacts={checkedArtifacts}
            setCheckedArtifacts={setCheckedArtifacts}
            refetch={refetch}
          />
        ),
      ]
      break
    default:
      actionButtons = [
        checkedArtifacts.length > 0 && checkedArtifactsIndicator,
        checkedArtifacts.length > 0 && (
          <UnrestrictSelectedActionButton
            key="unrestrict"
            checkedArtifacts={checkedArtifacts}
            setCheckedArtifacts={setCheckedArtifacts}
            refetch={refetch}
          />
        ),
        checkedArtifacts.length > 0 && (
          <RestrictSelectedActionButton
            key="restrict"
            checkedArtifacts={checkedArtifacts}
            setCheckedArtifacts={setCheckedArtifacts}
            refetch={refetch}
            patron={patron}
          />
        ),
        checkedArtifacts.length > 0 && (
          <DeleteSelectedActionButton
            key="delete"
            checkedArtifacts={checkedArtifacts}
            setCheckedArtifacts={setCheckedArtifacts}
            refetch={refetch}
          />
        ),
      ]
  }
  return (
    <Row gutters="nano" guttersY="sm" alignY="middle">
      <Checkbox
        label={t('selectedArtifactsActions.selectAll', 'Select All')}
        name="selectAllArtifacts"
        checked={selectAllArtifacts}
        onChange={selectAllArtifactsOnChange}
      />
      {actionButtons}
    </Row>
  )
}
